import React from 'react';
import Helmet from 'react-helmet';
import Link from '../common/TrackedLink';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';

const About = () => {
	return (
		<div className="about-us">
			<Helmet>
				<title>About Us &#124; SentrySafe</title>
				<meta name="description"
						content="SentrySafe provides peace of mind and protection for all your security needs. Learn more about the history of SentrySafe and the mission that guides our work." />
			</Helmet>

			<Breadcrumb>
				<BreadcrumbItem label="Learn" />
				<BreadcrumbItem label="About SentrySafe" />
			</Breadcrumb>

			<header className="row header-callout">
				<div className="col">
					<h1>About SentrySafe</h1>
					<p>Creating peace of mind for a lifetime.</p>
				</div>
			</header>

			<div className="accent-image">
				<img
					src={ require('../../resources/img/hero/about-us.jpg') }
					alt="Master Lock Company Office in Oak Creek, WI"
				/>
			</div>
			
			<section className="row">
				<div className="col title">
					<p>
						SentrySafe enables people to safeguard the important and irreplaceable. We give people the confidence to know that the valuables entrusted in their care are protected and can endure adverse conditions due to fire, flood or theft. People rely on SentrySafe to help them quickly recover from hardship by ensuring the things that matter most are well protected. 
						Creating peace of mind for a lifetime.
					</p>
				</div>
				<div className="col sm-6 section history">
					<h2 className="h3">Our History:</h2>
					<h3 className="h4">SentrySafe and Master Lock</h3>
					<p>
						Founded in 1930, SentrySafe is a global leader in offering
						fire&#45;resistant and security storage solutions for important documents and
						valuables. SentrySafe produces and distributes fire-resistant
						chests, files, safes and security storage containers to more than 54 countries
						worldwide. An affiliate of the Master Lock Company LLC, SentrySafe
						is the &#35;1 personal safe brand in the company portfolio. The Master Lock Company
						is recognized around the world as the authentic, enduring name in padlocks and
						security products. The Master Lock Company offers a broad range of innovative
						security and safety solutions for consumer, commercial, and industrial end-users.
						Master Lock Company LLC is an operating unit of Fortune Brands Innovations,
						a leading consumer brands company. Headquartered in Deerfield, Ill.,
						Fortune Brands Innovations (NYSE: FBIN), is included in the S&P 500 Index.&nbsp;
						<Link to="http://www.masterlock.com" target="_blank">Learn more about
						The Master Lock Company</Link>.
					</p>
				</div>
				<div className="col sm-6 section mission">
					<h2 className="h3">Our Mission</h2>
					<p>
						The Master Lock Company provides peace of mind
						and protection where people live, work and play. We
						have the most recognized, trusted and iconic
						security brands in our markets that promise
						best&#45;in&#45;class value, ease of use, durability,
						reliability, quality and service.
					</p>
					{/*<p><Link className="arrow-link" to="/learn/press-room">View our Press Room releases</Link></p>*/}
				</div>
			</section>
			
			<section className="row callout-dark">
				<div className="col sm-6 left">
					<h3 className="h4">Contact Us</h3>
					<img
						className="icon"
						src={ require('../../resources/img/icons/contact-us-icon.png') }
						alt="Contact Us"
					/>
					<p>
						Have questions or comments?<br />
						Our customer support is available to assist
						you with all your questions about our safes.
					</p>
					<Link
						to="/support/contact-us"
						className="arrow-link"
					>
						Contact Us
					</Link>
				</div>
				<div className="col sm-6 right">
					<h3 className="h4">FAQs</h3>
					<img
						className="icon"
						src={ require('../../resources/img/icons/faqs-icon.png') }
						alt="FAQs"
					/>
					<p>
						If you have additional questions about SentrySafe
						products, please visit our FAQs.
					</p>
					<Link
						to="/support/faqs"
						className="arrow-link"
					>
						View FAQs
					</Link>
				</div>
			</section>
		</div>
	);
};

export default About;


// WEBPACK FOOTER //
// ./src/pages/learn/About.js